import { INavPreviewCol } from "@models/nav.interface";
import { SolutionSlug } from "@models/pages/solution-page.interface";

interface ISolutionsPreviewState {
  columns: INavPreviewCol[];
}

export const SolutionsPreviewState: ISolutionsPreviewState = {
  columns: [
    {
      title: 'Solutions.Nav.UseCases.Title',
      cards: [
        {
          title: 'Solutions.Nav.Gaming.Title',
          subtitle: 'Solutions.Nav.Gaming.Subtitle',
          iconSrc: '/layout-images/header/solutions-preview/rocket.svg',
          href: `/solutions/${SolutionSlug.GAMING}`,
        },
        {
          title: 'Solutions.Nav.Exchanges.Title',
          subtitle: 'Solutions.Nav.Exchanges.Subtitle',
          iconSrc: '/layout-images/header/solutions-preview/arrows-repeat-outline.svg',
          href: `/solutions/${SolutionSlug.CRYPTO_EXCHANGES}`,
        },
        {
          title: 'Solutions.Nav.ListYourToken.Title',
          subtitle: 'Solutions.Nav.ListYourToken.Subtitle',
          iconSrc: '/layout-images/header/solutions-preview/rectangle-list.svg',
          href: `/solutions/${SolutionSlug.LIST_YOUR_TOKEN}`,
        },
      ],
    },
    {
      title: 'Solutions.Nav.CustomSolutions.Title',
      cards: [
        {
          title: 'Solutions.Nav.Nonprofits.Title',
          subtitle: 'Solutions.Nav.Nonprofits.Subtitle',
          iconSrc: '/layout-images/header/solutions-preview/heart.svg',
          href: `/solutions/${SolutionSlug.ACCEPT_CRYPTO_DONATIONS}`,
        },
        {
          title: 'Solutions.Nav.WhitelabelSolutions.Title',
          subtitle: 'Solutions.Nav.WhitelabelSolutions.Subtitle',
          iconSrc: '/layout-images/header/solutions-preview/layers.svg',
          href: `/solutions/${SolutionSlug.WHITELABEL}`,
        },
        {
          title: 'Solutions.Nav.MultiLevelKYC.Title',
          subtitle: 'Solutions.Nav.MultiLevelKYC.Subtitle',
          iconSrc: '/layout-images/header/solutions-preview/users.svg',
          href: `/solutions/${SolutionSlug.WEB3_KYC}`,
        },
      ],
    },
  ],
};
